import { ApplicationType, OfferPreview } from "@justhome/api-core";
import clsx from "clsx";
import { FC } from "react";
import InfoIcon from "../InfoIcon";
import { Locale } from "../lib/i18n";
import { offerLabels } from "../lib/labels";
import Skeleton from "../Skeleton";
import OfferLegalNoticePopover from "./OfferLegalNoticePopover";

interface OfferLegalNoticeProps {
  applicationType?: ApplicationType;
  offer?: OfferPreview;
  isLoading?: boolean;
  locale: Locale;
  className?: string;
}

const OfferLegalNotice: FC<OfferLegalNoticeProps> = ({
  applicationType,
  offer,
  isLoading,
  locale,
  className,
}) => {
  const isOfferLoans = !!offer?.loans;
  const labels = offerLabels[locale];

  return (
    <Skeleton
      isLoading={isLoading}
      width={82}
      height={20}
      className={className}
    >
      <div
        data-testid="legal-notice"
        className={clsx(
          "text-app-caption-1 flex items-center text-neutral-575/50 gap-xs",
          className,
        )}
      >
        {labels.label}
        {isOfferLoans && (
          <InfoIcon size="sm">
            <OfferLegalNoticePopover
              applicationType={applicationType}
              offer={offer}
              locale={locale}
            />
          </InfoIcon>
        )}
      </div>
    </Skeleton>
  );
};

export default OfferLegalNotice;
